import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const HeroSection = styled.section`
  height: 100vh;
  background-image: url('${process.env.PUBLIC_URL}/images/mybackground.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 2rem;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  color: white;
  max-width: 800px;
  margin: 0 auto;
`;

const Name = styled(motion.h1)`
  font-size: 4rem;
  margin-bottom: 1rem;
`;

const Title = styled.p`
  font-size: 1.5rem;
  margin-bottom: 2rem;
`;

const Links = styled.div`
  display: flex;
  gap: 1rem;
`;

const LinkButton = styled(motion.a)`
  padding: 0.8rem 1.5rem;
  border: 2px solid white;
  border-radius: 30px;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: white;
    color: black;
  }
`;

const Hero = () => {
  return (
    <HeroSection>
      <Content>
        <Name
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          ByeongSu Ko
        </Name>
        <Title>Researcher • Developer • Innovator</Title>
        <Links>
          <LinkButton
            href="https://github.com/eclipse1228"
            target="_blank"
            whileHover={{ scale: 1.05 }}
          >
            Github
          </LinkButton>
          <LinkButton
            href="https://www.linkedin.com/in/byeongsu-go-697942246/"
            target="_blank"
            whileHover={{ scale: 1.05 }}
          >
            LinkedIn
          </LinkButton>
        </Links>
      </Content>
    </HeroSection>
  );
};

export default Hero;
